// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_form__C-XjH {
    display: flex;
    align-items: center;
    grid-gap: 8px;
}

.styles_form__C-XjH img {
    width: 15px;
}

.styles_form__C-XjH label,
.styles_form__C-XjH p {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*font-size: 16px;*/
    margin-bottom: 5px;
}

.styles_form__C-XjH label input,
.styles_form__C-XjH p span {
    width: 70px;
    max-width: 70px;

    padding: 0 6px;
    text-align: center;
}

.styles_form__C-XjH label input {
    height: 24px;
    border: 0.5px dashed var(--dark-grey);
    color: var(--primary-color);
}

.styles_title__sStXK {
    display: flex;
    grid-gap: 10px;
    color: var(--dark-grey);
    text-wrap: nowrap;
}

.styles_iconPlaceholder__TsTLk {
    width: 20px;
}

.styles_content__x9RoO {
    min-width: 100%;
}

.styles_form__C-XjH > div {
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/TaxOptimisation/components/BaseInputs/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,eAAe;;IAEf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".form {\n    display: flex;\n    align-items: center;\n    grid-gap: 8px;\n}\n\n.form img {\n    width: 15px;\n}\n\n.form label,\n.form p {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    /*font-size: 16px;*/\n    margin-bottom: 5px;\n}\n\n.form label input,\n.form p span {\n    width: 70px;\n    max-width: 70px;\n\n    padding: 0 6px;\n    text-align: center;\n}\n\n.form label input {\n    height: 24px;\n    border: 0.5px dashed var(--dark-grey);\n    color: var(--primary-color);\n}\n\n.title {\n    display: flex;\n    grid-gap: 10px;\n    color: var(--dark-grey);\n    text-wrap: nowrap;\n}\n\n.iconPlaceholder {\n    width: 20px;\n}\n\n.content {\n    min-width: 100%;\n}\n\n.form > div {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `styles_form__C-XjH`,
	"title": `styles_title__sStXK`,
	"iconPlaceholder": `styles_iconPlaceholder__TsTLk`,
	"content": `styles_content__x9RoO`
};
export default ___CSS_LOADER_EXPORT___;
